import { PROSPECT_STAGES, prospectStageIndex } from "@shared/prospectConstants";

/** The five milestones, with Convert to Client as the dashed last segment, always available. */
export function ProspectStepper({ stage, onSelect, onConvert }: { stage: string | null; onSelect: (s: string) => void; onConvert: () => void }) {
  const current = Math.max(0, prospectStageIndex(stage));
  return (
    <div className="flex items-center gap-0.5">
      {PROSPECT_STAGES.map((s, i) => (
        <button
          key={s}
          onClick={() => onSelect(s)}
          title={i === current ? "Current stage" : `Move to ${s}`}
          className={`flex-1 py-2 text-xs font-medium text-center transition-all first:rounded-l-lg ${
            i === current ? "bg-primary text-primary-foreground" : i < current ? "bg-primary/15 text-primary-text" : "bg-muted text-muted-foreground hover:bg-muted/80"
          }`}
        >
          {s}
        </button>
      ))}
      <button
        onClick={onConvert}
        className="flex-1 py-2 text-xs font-semibold text-center rounded-r-lg border border-dashed border-green-700 text-green-700 dark:text-green-400 hover:bg-green-50 dark:hover:bg-green-950/30"
      >
        Convert to Client →
      </button>
    </div>
  );
}
